import { Actions, TableActionTypes } from '../_actions/table.actions';
import { Error } from '../_models/auth.models';
import { Operations, OpTypes } from '../_models/general.model';
import {
  ITable,
  Navigation,
  ValidateTablePayload,
} from '../_models/table.models';

/**
 * State interface
 */
export interface TableState {
  navigation: {
    [key: string]: Array<Navigation>;
  };
  error: Error | null;
  validateName: {
    [applicationId: string]: ValidateTablePayload | null;
  };
  tables: {
    [applicationId: string]: Array<ITable>;
  };
  allTables: {
    [applicationId: string]: Array<any>;
  };
  checkTableData: {
    [tableId: string]: boolean
  };
  operations: Operations;
  tablesLoading:{[key:string]:boolean};
  allTablesLoading:{[key:string]:boolean};
}

/**
 * Initials State
 */
export const initialState: TableState = {
  navigation: {},
  error: null,
  operations: {},
  validateName: {},
  tables: {},
  allTables: {},
  checkTableData: {},
  tablesLoading:{},
  allTablesLoading:{},
};

/**
 * Reducer
 */
export const TableReducer = (
  state = initialState,
  action: Actions
): TableState => {
  switch (action.type) {
    case TableActionTypes.LOAD_ALL_TABLES:
      return {
        ...state,
        allTablesLoading:{ ...state.allTablesLoading, [action.applicationId]:true, [`error-${action.applicationId}`]:false}
      }
    case TableActionTypes.LOAD_ALL_TABLES_FAILED:
      return {
        ...state,
        allTablesLoading: {...state.allTablesLoading, [action.applicationId]:false, [`error-${action.applicationId}`]:true}
      }
    case TableActionTypes.UPDATE_TABLE_SUCCESS:
      const navigation: Array<Navigation> = JSON.parse(
        JSON.stringify(state.navigation[action.applicationId])
      );
      // find table id and update name
      navigation[
        navigation.findIndex(
          (nav: any) => nav.LevelIds.TableId === action.tableId
        )
      ].Title = action.payload.Name;
      return {
        ...state,
        navigation: {
          ...state.navigation,
          [action.applicationId]: navigation,
        },
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.UPDATE,
            error: null,
            payload:action.payload
          },
        },
      };
    case TableActionTypes.DELETE_TABLE_SUCCESS:
      const index = state.navigation[action.applicationId].findIndex(
        (nav: any) => nav.LevelIds.TableId === action.tableId
      );
      return {
        ...state,
        navigation: {
          ...state.navigation,
          [action.applicationId]: [
            ...state.navigation[action.applicationId].slice(0, index),
            ...state.navigation[action.applicationId].slice(index + 1),
          ],
        },
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.DELETE,
            error: null,
          },
        },
      };
    case TableActionTypes.LOAD_NAVIGATION_SUCCESS:
      // if(state.navigation[action.applicationId] && action.payload.every((item:any)=> item.hasOwnProperty('LayoutKey'))){
      //   const defaultNavigation = JSON.parse(JSON.stringify(state.navigation[action.applicationId]))
      //   defaultNavigation.map((nav:any,index:any)=>{
      //     return {...action.payload[index],IsExpanded:nav.IsExpanded};
      //   })
      //   return {
      //     ...state,
      //     navigation: {
      //       ...state.navigation,
      //       [action.applicationId]: defaultNavigation,
      //     },
      //   };
      // }
      return {
        ...state,
        navigation: {
          ...state.navigation,
          [action.applicationId]: action.payload,
        },
      };
    case TableActionTypes.TOGGLE_NAVIGATION:
      let toggledNavigation = JSON.parse(JSON.stringify(state.navigation[action.applicationId]));
      toggledNavigation = toggledNavigation.map((navigation:any)=>{
        if(navigation.Order == action.order){
          navigation.IsExpanded = action.isExpended;
        } 
        return navigation;
      })
      return {
        ...state,
        navigation: {
          ...state.navigation,
          [action.applicationId]: toggledNavigation,
        },
      };
    case TableActionTypes.CREATE_TABLE_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.CREATE,
            error: null,
            payload: action.payload,
          },
        },
      };
    case TableActionTypes.ARRANGE_TABLE_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.UPDATE,
            error: null,
          },
        },
      };
    case TableActionTypes.LOAD_TABLES_FAILED:
      return {
        ...state,
        tablesLoading:{...state.tablesLoading, [action.applicationId]:false, [`error-${action.applicationId}`]:true} 
      }
    case TableActionTypes.CREATE_TABLE_FAILED:
    case TableActionTypes.ARRANGE_TABLE_FAILED:
    case TableActionTypes.DELETE_TABLE_FAILED:
    case TableActionTypes.UPDATE_TABLE_FAILED:
      return {
        ...state,
        operations: {
          ...state.operations,
          [action.refId]: {
            type: OpTypes.FAILED,
            error: action.payload,
          },
        },
      };
    case TableActionTypes.VALIDATE_TABLE_NAME:
      return {
        ...state,
        validateName: {
          ...state.validateName,
          [action.applicationId]: null,
        },
      };
    case TableActionTypes.VALIDATE_TABLE_NAME_SUCCESS:
      return {
        ...state,
        validateName: {
          ...state.validateName,
          [action.applicationId]: action.payload,
        },
      };
    case TableActionTypes.LOAD_TABLES_SUCCESS:
      return {
        ...state,
        tables: {
          ...state.tables,
          [action.applicationId]: action.payload,
        },
        tablesLoading:{...state.tablesLoading, [action.applicationId]:false, [`error-${action.applicationId}`]:false}
      };
    case TableActionTypes.LOAD_ALL_TABLES_SUCCESS:
      return {
        ...state,
        allTables: {
          ...state.allTables,
          [action.applicationId]: action.payload,
        },
        allTablesLoading:{...state.allTablesLoading, [action.applicationId]:false, [`error-${action.applicationId}`]:false}
      };
    case TableActionTypes.LOAD_ALL_TABLES_SUCCESS:
      return {
        ...state,
        allTables: {
          ...state.allTables,
          [action.applicationId]: action.payload,
        },
      };
    case TableActionTypes.LOAD_TABLES:
      return{
        ...state,
        error:null,
        tablesLoading:{...state.tablesLoading, [action.applicationId]:true, [`error-${action.applicationId}`]:false}
      }
    case TableActionTypes.TABLE_HAS_DATA:
    case TableActionTypes.CREATE_TABLE:
    case TableActionTypes.ARRANGE_TABLE:
    case TableActionTypes.DELETE_TABLE:
    case TableActionTypes.UPDATE_TABLE:
    case TableActionTypes.LOAD_NAVIGATION:
      return {
        ...state,
        error: null,
      };
    case TableActionTypes.LOAD_PAGES_DASHBOARD_SUCCESS:
      return {
        ...state,
        tables: {
          ...state.tables,
          [action.tableId]: action.payload,
        },
      };

      case TableActionTypes.TABLE_HAS_DATA_SUCCESS:
      return {
        ...state,
        checkTableData: {
          ...state.checkTableData,
          [action.tableId]: action.hasData,
        },
      };
    case TableActionTypes.RESET:
      return initialState;
    default:
      return state;
  }
};
